import { serverAddr, fileServerAddr, extenapiServerAddr, serverAddrForCSV } from "../networkConfig";
import axios from "axios";

export default {
	getAllStoreData() {
		return serverAddr.get("outlet/?get_all=true");
	},
	getAllStoreDataCluster() {
		return serverAddr.get("outlet/?all_outlets=true");
	},
	getHeadOfficeOutlets() {
		return serverAddr.get("outlet/?type=head_office");
	},
	getNominatedStores() {
		return serverAddr.get("/tasks/get_nominated_stores/");
	},
	getOrderTypes() {
		return serverAddr.get("sales/get_all_sales_order_type/");
	},
	getStoreData() {
		return serverAddr.get("outlet/");
	},
	getSavedStoreData() {
		return serverAddr.get("read/saved/stores");
	},
	addShiftForStoreDetails(params) {
		return serverAddr.post("/add/update/store-shift-info/", params);
	},
	getStoreHoursListDropdown() {
		return serverAddr.get("read/yes-no-dropdown/");
	},
	getStoreClosedOnDropdown() {
		return serverAddr.get("/read/store-closed-dropdown/");
	},
	addStoreDetails(params) {
		return serverAddr.post("/settings/store/details/", params);
	},
	getAutoStoreDetails(storeID) {
		return serverAddr.post("/read/store-details/", storeID);
	},
	addBusinessDays(storeID, params) {
		return serverAddr.post(`/business_days/?store=${storeID}`, params);
	},
	getBusinessDays(storeID) {
		return serverAddr.get(`/settings/business/days/?store=${storeID}`);
	},
	getAllBusinessDays(storeID) {
		return serverAddr.get(`settings/business/days/get_all_store_times/?store=${storeID}`);
	},
	getWorkArea(storeID) {
		return serverAddr.post("read/store-functions/", storeID);
	},
	getFunctionByArea(storeID) {
		return serverAddr.post("read/create_task_functions/", storeID);
	},
	getOverLapFunctions(storeID) {
		return serverAddr.get(`/read/function/overlaps/?store=${storeID}`);
	},
	getSections(params) {
		return serverAddr.post(`/read/store_sections/`, params);
	},
	addSections(params) {
		return serverAddr.post(`/add/update/store_section/`, params);
	},
	deleteSections(id) {
		return serverAddr.post(`/delete/store_sections/`, id);
	},
	getEmpShiftPreference(params) {
		return serverAddr.post(`/employee/get/employee_prefrence/`, params);
	},
	addEmpShiftPreference(params) {
		return serverAddr.post(`/employee/add_update/employee_prefrence/`, params);
	},
	deleteEmpShiftPreference(params) {
		return serverAddr.post(`/employee/delete/employee_prefrence/`, params);
	},
	addWorkArea(params) {
		return serverAddr.post("add/update-store-functions/", params);
	},
	addDepartment(params) {
		return serverAddr.post("add/update-store-departments/", params);
	},
	getDepartment(storeID) {
		return serverAddr.post("/read/store-departments/", storeID);
	},
	getShiftForStoreDetails(storeID) {
		return serverAddr.post("/read/store-shifts/", storeID);
	},
	addOverLapFunction(params) {
		return serverAddr.post("/function/overlaps/", params);
	},
	deleteOverLapFunction(id) {
		return serverAddr.get(`/delete/function/overlaps/?id=${id}`);
	},
	deleteFunctions(params) {
		return serverAddr.post("delete/function/", params);
	},
	deleteDesignation(params) {
		return serverAddr.post("/store-designations/delete/", params);
	},
	deleteDepartmentFunction(params) {
		return serverAddr.post("reset/function/", params);
	},
	deleteDepartment(params) {
		return serverAddr.post("delete/department/", params);
	},
	getShiftListDropdown() {
		return serverAddr.get("read/shift-type/");
	},
	getGenderListDropdown() {
		return serverAddr.get("read/genders/");
	},
	getPlanningShiftDay() {
		return serverAddr.get("read/days/");
	},
	getStaffDetails(storeID) {
		return serverAddr.post("read/store-staff-info/", storeID);
	},
	addEmployees(data) {
		return serverAddr.post("add/bulk-employess/", data);
	},
	addUpddteEmpPayType(data) {
		return serverAddr.post("employee/paytype/save/", data);
	},
	getSelectShiftListDropdown() {
		return serverAddr.get("read/employee-type/");
	},
	deleteEmpDetail(params) {
		return serverAddr.post("delete/employee/", params);
	},
	deleteShiftDetails(params) {
		return serverAddr.post("delete/shift/", params);
	},
	addStaffDetails(params) {
		return serverAddr.post("add/update/store-staff-info/", params);
	},
	downloadTemplate() {
		return serverAddr.get("download/employee-csv/");
	},
	AddActivityDetails(data) {
		return serverAddr.post("create/update/store_activities/", data);
	},
	addPlanningType(data) {
		return serverAddr.post("/update/function-planning-criteria/", data);
	},
	addPreparationActivities(data) {
		return serverAddr.post("/create/update/preparation_activities/", data);
	},
	addTransactionActivities(data) {
		return serverAddr.post("/create/update/transaction_activities/", data);
	},
	addDailyActivities(data) {
		return serverAddr.post("/create/update/daily_activities/", data);
	},
	addHourActivities(data) {
		return serverAddr.post("/create/update/function_per_hour_req/", data);
	},
	getCategory() {
		return serverAddr.get("/categories/");
	},
	getAllCategory() {
		return serverAddr.get("/categories/?get_all=true");
	},
	getAllSubCategories() {
		return serverAddr.get("/product/subcategory/?get_all=true");
	},
	addAllActivities(preparationParams,transactionParams,dailyParams) {
		return axios.all([
			this.addPreparationActivities(preparationParams),
			this.addTransactionActivities(transactionParams),
			this.addDailyActivities(dailyParams),

		]);
	},
	getFunctionalActivities(params) {
		return axios.all([
			this.getDepartment(params),
			this.getWorkArea(params),
			this.getPreparationActivities(params),
			this.getTransactionActivities(params),
			this.getDailyActivities(params),
			this.getFunctionPerHrsAct(params),
			this.getActivitesTypeList(params),
		]);
	},
	getPreparationActivities(params) {
		return serverAddr.post("/read/preparation_activities/", params);
	},
	getTransactionActivities(params) {
		return serverAddr.post("/read/transaction_activities/", params);
	},
	getDailyActivities(params) {
		return serverAddr.post("/read/daily_activities/", params);
	},
	addActivityType(params) {
		return serverAddr.post("/activity/type/", params);
	},
	updateActivityType(params) {
		return serverAddr.patch(`/activity/type/${params.id}/`, params);
	},
	getFunctionPerHrsAct(params) {
		return serverAddr.post("/read/function_per_hour_req/", params);
	},
	getActivitesTypeList(params) {
		return serverAddr.get(`/activity/type/?store=${params.outlet_id}&get_all=${true}`);
	},
	saveDailyActivities(params) {
		return serverAddr.post(`/create/update/daily_activities/`, params);
	},
	deleteDailyActivities(params) {
		return serverAddr.post(`/delete/daily-activities/`, params);
	},
	deleteActivityType(params) {
		return serverAddr.delete(`/activity/type/${params.id}`);
	},
	getActivities(data) {
		return serverAddr.post("/read/store_activities/", data);
	},
	deleteAvgTimes(data) {
		return serverAddr.post("delete/average-time-catagory/", data);
	},
	deleteAvgTimesSubCategory(data) {
		return serverAddr.post("delete/average-time-subcatagory/", data);
	},
	deleteDeparmentActivity(data) {
		return serverAddr.post("/delete/average-time-product-department/", data);
	},
	deleteTrancAndFFootfallHour(data) {
		return serverAddr.post("delete/function_per_hour_req/", data);
	},
	addBufferLevel(data) {
		return serverAddr.post("/create/update/buffer_level/", data);
	},
	getBufferLevel(data) {
		return serverAddr.post("/read/buffer_level/", data);
	},
	deleteLinkeds(data) {
		return serverAddr.post("delete/linked-activities/", data);
	},
	deleteDailys(data) {
		return serverAddr.post("delete/daily-activities/", data);
	},
	categoryAdtIptNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/category/day/ipt/", data);
	},
	updateCategoryIptNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/update-category-ipt/", data);
	},
	updateAdtIptNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/update-adt-ipt/", data);
	},
	upcomingWeekDetails(data) {
		return serverAddr.post("sheduling/adt-ipt/upcoming-week-details/", data);
	},
	shedulingPartnerSummaryNetworkCallBack(data) {
		return serverAddr.post("/sheduling/partner/summary_new/", data);
	},
	readAdtIptWeekDay(data) {
		return serverAddr.post("sheduling/adt-ipt/query/", data);
	},
	addIplh(data) {
		return serverAddr.post("iplh/", data);
	},
	getIplhDetails(data) {
		return serverAddr.post("iplh/read_iplh/", data);
	},
	updateIplhs(_storeId, data) {
		return serverAddr.put(`/iplh/${_storeId}/`, data);
	},
	updateWeekDetail(data) {
		return serverAddr.post(
			"sheduling/adt-ipt/update-upcoming-week-details/",
			data
		);
	},
	shedulingActualSummaryNetworkCallBack(storeID, get_all, formDate, toDate) {
		return serverAddr.get(
			`sheduling/actual/week-summary/?get_all=${get_all}&from_date=${formDate}&to_date=${toDate}&outlet=${storeID}`
		);
	},
	readAdtIptActualSummaryNetworkCallBack(storeID, get_all, formDate, toDate) {
		return serverAddr.get(
			`sheduling/actual/adt-ipt/?get_all=${get_all}&from_date=${formDate}&to_date=${toDate}&outlet=${storeID}`
		);
	},
	readCategoryIptActualSummaryNetworkCallBack(
		storeID,
		get_all,
		formDate,
		toDate
	) {
		return serverAddr.get(
			`sheduling/actual/category-ipt/?get_all=${get_all}&from_date=${formDate}&to_date=${toDate}&outlet=${storeID}`
		);
	},
	updateAdtIptActualSummarytNetworkCallBack(data) {
		return serverAddr.post("sheduling/actual/adt-ipt/create-update/", data);
	},
	updateCategoryiptActualSummarytNetworkCallBack(data) {
		return serverAddr.post(
			"sheduling/actual/category-ipt/create-update/",
			data
		);
	},
	updateIptActualSummaryNetworkCallBack(data, id) {
		return serverAddr.put(`/sheduling/actual/week-summary/${id}/`, data);
	},
	createIptActualSummaryNetworkCallBack(data) {
		return serverAddr.post("/sheduling/actual/week-summary/", data);
	},
	partnerSummary(data) {
		return serverAddr.post("/sheduling/partner/summary_new/", data);
	},
	reportSummary(data) {
		return serverAddr.post("/sheduling/partner/report-page/summary/", data);
	},
	getProjectValuesNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/query/", data);
	},
	getHourlyBasedAdtIptNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/hourly-category-ipt/", data);
	},
	updateHourlyBasedAdtIptNetworkCallBack(data) {
		return serverAddr.post("sheduling/adt-ipt/update-hourly-adt-ipt/", data);
	},
	getPlannedValuesNetworkCallBack(data) {
		return serverAddr.post("sheduling/partner/read-coverage-hours/", data);
	},
	getPercentValueNetworkCallBack(params) {
		return serverAddr.post("sheduling/adt-ipt/planned-forecast-percentage/", params);
	},
	getAllEmployeeListNetworkCallBack(storeID) {
		return serverAddr.post("read/employees/", storeID);
	},
	getAllEmployeeDetailsNetworkCallBack(storeID) {
		return serverAddr.post("read/employees_for_scheduler/", storeID);
	},
	saveUserAccessTrackRecord(params) {
		return serverAddr.post("sheduling/reports/user-report-access-save/", params);
	},
	getSortEmployeeListNetworkCallBack(storeID, date) {
		return serverAddr.post(`read/employees_for_scheduler/?date=${date}`, storeID);
		// return serverAddr.post(`read/employees/?date=${date}`, storeID);
	},
	getEmployeesDayWiseDataNetworkCallBack(storeID, get_all, formDate, toDate) {
		return serverAddr.get(
			`sheduling/partner/?get_all=${get_all}&from_date=${formDate}&to_date=${toDate}&store=${storeID}&view=weekly`
		);
	},
	getEmployeesDataNetworkCallBack(storeID, formDate, toDate, get_all) {
		return serverAddr.get(
			`sheduling/partner/?get_all=${get_all}&from_date=${formDate}&to_date=${toDate}&store=${storeID}`
		);
	},
	getTotalDutyHoursOfEmployeesNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/partners-total-hours/`, params);
	},
	getStoreDepartMentsNetworkCallBack(params) {
		return serverAddr.post(`/read/store-departments/`, params);
	},
	getSchedulerData(
		partnerSummaryParams,
        percentageLabourHrsParams,
        employeeDayWiseShifDataParams,
        employeeTotalDuytHoursParams,
        weeklyOffparams,
        employeeLeaveDataParams,
        employeeShiftHoursParams,
        getCoverageHourParams,
		storeFunctionParams,
		employeeListParams,
        // getTaskParams,
		getStoreDepartMentsParams,
		getIdealLabourHourParams
	){
		return axios.all([
			this.partnerSummary(partnerSummaryParams),
			this.getPercentValueNetworkCallBack(percentageLabourHrsParams),
			this.getEmployeesDayWiseDataNetworkCallBack(
				employeeDayWiseShifDataParams.store_id,
				employeeDayWiseShifDataParams.get_all,
				employeeDayWiseShifDataParams.start_date,
				employeeDayWiseShifDataParams.end_date
			),
			this.getTotalDutyHoursOfEmployeesNetworkCallBack(employeeTotalDuytHoursParams),
			this.getAllWeeklyOffNetworkCallBack(weeklyOffparams),
			this.getAllLeaveOfEmployeeNetworkCallBack(employeeLeaveDataParams),
			this.getStaffDetails(employeeShiftHoursParams),
			this.getCoverageHoursNetworkCallBack(getCoverageHourParams),
			this.getWorkArea(storeFunctionParams),
			this.getAllEmployeeDetailsNetworkCallBack(employeeListParams),
			// this.getAssignedAndUnAssignedTasks(getTaskParams),
			this.getStoreDepartMentsNetworkCallBack(getStoreDepartMentsParams),
			this.getDeptWiseManpowerNetworkCallBack(getIdealLabourHourParams),
			this.getIdealLabourNetworkCallBack(getIdealLabourHourParams)
		]);
	},
	getEmployeeDailyShiftDataNetworkCallBack(
		weatherDetailsParams,
		projectedValuesParams,
		percentageLabourHrsParams,
		ActualTransactionParams,
		getStoreEventsParams,
		storeTimingParams,
		storeFunctionParams,
		storeDepartmentParams,
		employeeListParams,
		employeeDayWiseShifDataParams,
		employeeTotalDuytHoursParams,
		weeklyOffparams,
		employeeLeaveDataParams,
		employeeShiftHoursParams,
		getIdealLabourHourParams,
		getStoreDepartMentsParams,
		getCoverageHourParams,
		getWeeklyShiftParam
	) {
		return axios.all([
			this.getWeatherInfoForWeek(weatherDetailsParams),
			this.getProjectValuesNetworkCallBack(projectedValuesParams),
			this.getPercentValueNetworkCallBack(percentageLabourHrsParams),
			this.getNewApiForActualTransactionNetworkCallBack(ActualTransactionParams),
			this.getStoreEvents(getStoreEventsParams),
			this.storeOpenCloseTime(storeTimingParams),
			this.getWorkArea(storeFunctionParams),
			this.getDepartment(storeDepartmentParams),
			this.getAllEmployeeDetailsNetworkCallBack(employeeListParams),
			this.getTotalDutyHoursOfEmployeesNetworkCallBack(employeeTotalDuytHoursParams),
			this.getAllWeeklyOffNetworkCallBack(weeklyOffparams),
			this.getAllLeaveOfEmployeeNetworkCallBack(employeeLeaveDataParams),
			this.getStaffDetails(employeeShiftHoursParams),
			this.getIdealLabourNetworkCallBack(getIdealLabourHourParams),
			this.getStoreDepartMentsNetworkCallBack(getStoreDepartMentsParams),
			this.getCoverageHoursNetworkCallBack(getCoverageHourParams),
			this.getDeptWiseManpowerNetworkCallBack(getIdealLabourHourParams),
			this.getEmployeesWeeklyWiseDataNetworkCallBack_V2(getWeeklyShiftParam),
		]);
	},
	getVarianceFor(params) {
		return serverAddr.post(`/sheduling/adt-ipt/get-hourly-variance/`, params);
	},
	getFixedVarLabourHour(params) {
		return serverAddr.post(`/sheduling/adt-ipt/get_fixed_and_var_ideal_labours/`, params);
	},
	saveShiftOfEmployeeNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/`, params);
	},
	saveWeeklyOffNetworkCallBack(params) {
		return serverAddr.post(`/employee/weekoff/create-update/`, params);
	},
	getAllWeeklyOffNetworkCallBack(params) {
		return serverAddr.get(
			`/employee/weekoff/?get_all=${params.getAll}&start_date=${
				params.fromDate
			}&end_date=${params.toDate}&store=${params.store_id}`
		);
	},
	deleteEmployeeWeekOffNetworkCallBack(params) {
		return serverAddr.delete(`/employee/weekoff/${params.id}`);
	},
	updateShiftOfEmployeeNetworkCallBack(params, id) {
		return serverAddr.patch(`/sheduling/partner/${id}/`, params);
	},
	updateSplitShiftInBulkNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/bulk-create-update-shifts/`, params);
	},
	copyShiftToOtherDatesNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/copy-shift/`, params);
	},
	deleteShiftOfEmployeeNetworkCallBack(id) {
		return serverAddr.delete(`/sheduling/partner/${id}/`);
	},
	deleteBulkShiftOfEmployeeNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/delete-multiple-shifts/`, { ids: params });
	},
	getAllLeaveOfEmployeeNetworkCallBack(params) {
		return serverAddr.get(
			`/employee/leaves/list/?get_all=${params.get_all}&start_date=${
				params.start_date
			}&end_date=${params.end_date}&store=${params.store_id}`
		);
	},
	addLeaveOfEmployeeNetworkCallBack(params) {
		return serverAddr.post(`/employee/leaves/save/`, params);
	},
	updateLeaveOfEmployeeNetworkCallBack(id, params) {
		return serverAddr.patch(`/employee/leaves/${id}/`, params);
	},
	deleteLeaveOfEmployeeNetworkCallBack(params) {
		return serverAddr.post(`/employee/leaves/delete/`, params);
	},
	getActualTransactionNetworkCallBack(params) {
		return serverAddr.get(
			`/sheduling/actual/adt-ipt/?get_all=${params.get_all}&from_date=${
				params.from_date
			}&to_date=${params.to_date}&outlet=${params.outlet}`
		);
	},
	saveHourlyTransactionsNetWorkCallBack(params){
		return serverAddr.post(`/sheduling/adt-ipt/update-hourly-transactions/`, params);
	},
	getNewApiForActualTransactionNetworkCallBack(params) {
		return serverAddr.post(`/sales/query/`, params);
	},
	getWeatherInfoNetworkCallBack(params) {
		return serverAddr.get(
			`/weather/?from_date=${params.from_date}&to_date=${
				params.to_date
			}&outlet=${params.outlet}`
		);
	},
	getEvents(params) {
		return serverAddr.get(
			`/event/?get_all=${params.get_all}&from_date=${
				params.from_date
			}&to_date=${params.to_date}&outlet=${params.outlet}`
		);
	},
	getStoreEvents(params) {
		return serverAddr.post(`/event/list/?get_all=${true}`, params);
	},
	createNewEvent(params) {
		return serverAddr.post(`/event/`, params);
	},
	getIdealLabourNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/adt-ipt/get_ideal_labours/`, params);
	},
	getCoverageHoursNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/get-coverage-hours/`, params);
	},
	updateEvent(params, id) {
		return serverAddr.patch(`/event/${id}/`, params);
	},
	getEventyCategory() {
		return serverAddr.get(`/event_category/?get_all=true`);
	},
	deleteEvent(id) {
		return serverAddr.delete(`/event/${id}/`);
	},
	getReportsNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/reports/query/`, params);
	},
	autoScheduleNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/adt-ipt/auto/shedule/`, params);
	},
	autoPlanNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/adt-ipt/auto/plan/`, params);
	},
	undoChangesPlanNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/undo/plan/`, params);
	},
	deleteBulkShiftNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/delete-bulk-shifts/`, params);
	},
	getShiftSummary(params) {
		return serverAddr.post(`/sheduling/partner/shift-summary/`, params);
	},
	getBreakHourCount(params) {
		return serverAddr.post(`/sheduling/partner/break-hour-count/`, params);
	},
	getCompanyData() {
		return serverAddr.get("/company/self/");
	},
	addPartTimeShiftData(params) {
		return serverAddr.post(
			"/sheduling/partner/bulk-create-update-shifts/",
			params
		);
	},
	swapShift(params) {
		return serverAddr.post("/sheduling/partner/swap-shifts/", params);
	},
	getBreakFactor() {
		return serverAddr.get("/settings/ideal/breakfactor/?get_all=true");
	},
	addBreakFactor(params) {
		return serverAddr.post(
			"/settings/ideal/breakfactor/create-update/",
			params
		);
	},
	delteBreakFactor(id) {
		return serverAddr.delete(`/settings/ideal/breakfactor/${id}/`);
	},
	getStoreDepartments(params) {
		return serverAddr.post(`/read/store-departments/`, params);
	},
	saveCreateTaskCategory(params) {
		return serverAddr.post(`/add/update/task/`, params);
	},
	getAllTasks(params) {
		return serverAddr.post(`/read/tasks/?get_all=true`, params);
	},
	getAssignedAndUnAssignedTasks(params) {
		return serverAddr.post(`/task_assignment/list/?get_all=true`, params);
	},
	deleteAssignTask(id) {
		return serverAddr.post(`/delete/task_assignment_by_id/`, id);
	},
	deleteUnassignTask(id) {
		return serverAddr.post(`/delete/task_by_id/`, id);
	},
	getTasksByDepartment(params) {
		return serverAddr.post(`/read/tasks_for_departments/`, params);
	},
	getEmployeesForTaskList(params) {
		return serverAddr.post(`/read/employees_availability_for_task/`, params);
	},
	getEmployeesListToAssignTask(params){
		return serverAddr.post(`/read/employees_task_availability_for_day/`, params);
	},
	saveAssignedTaskToEmployees(params) {
		return serverAddr.post(`/add-update/task_assignment_by_availability/`, params);
	},
	assignedTaskToEmployees(params) {
		return serverAddr.post(`/add-update/task_assignment/`, params);
	},
	updateAssingedTask(params) {
		return serverAddr.post(`/add-update/task_assignment_by_day_availability/`, params);
	},
	getTasksOfEmployee(params){
		return serverAddr.post(`/task_assignment/list/?get_all=true/`, params);
	},
	getStoreFunctionsByDepartments(params) {
		// return serverAddr.post(`/read/store-functions-for-department/`, params);
		return serverAddr.post(`/read/store-functions/`, params);
	},
	updateTaskAssignmentStatus(params) {
		// return serverAddr.post(`/read/store-functions-for-department/`, params);
		return serverAddr.post(`/update/task_assignment_status/`, params);
	},
	getTaskListForEmployee(params) {
		// return serverAddr.post(`/read/store-functions-for-department/`, params);
		return serverAddr.post(`/read/assigned_tasks_for_employee/`, params);
	},
	changeSubTaskStatus(params) {
		return serverAddr.post(`/set/complete_subtask/`, params);
	},
	removeAttachmentFile(params) {
		return serverAddr.post(`/task-status-attachment/delete/`, params);
		// return serverAddr.post(`/delete/attachment_to_task_assignment/`, params);
	},
	getImageUrlByPath(params) {
		return serverAddr.post(`/common/get-attachment-url/`, params);
	},
	getStoreDepartMentsNetworkCallBack(params) {
		return serverAddr.post(`/read/store-departments/`, params);
	},
	getIdealLabourNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/adt-ipt/get_ideal_labours/`, params);
	},
	getCoverageHoursNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/partner/get-coverage-hours/`, params);
	},
	getDeptWiseManpowerNetworkCallBack(params) {
		return serverAddr.post(`/sheduling/adt-ipt/dept-wise-manpower/`, params);
	},
	getDepartmentWiseData(
		getStoreDepartMentsParams,
		getIdealLabourHourParams,
		getCoverageHourParams
	) {
		return axios.all([
			// this.getStoreDepartMentsNetworkCallBack(getStoreDepartMentsParams),
			// this.getWorkArea(getStoreDepartMentsParams),
			// this.getProjectValuesNetworkCallBack(getIdealLabourHourParams),
			// this.getIdealLabourNetworkCallBack(getIdealLabourHourParams),
			// this.getCoverageHoursNetworkCallBack(getCoverageHourParams),
			this.getDeptWiseManpowerNetworkCallBack(getIdealLabourHourParams)
		]);
	},
	getTimeSheetNetWorkCallBack(params){
		return serverAddr.post(`/timesheet/list/`, params);
	},
	getTodaysTimeSheetNetworkCallBack(
		employeeListParams,
		employeeShiftDetailsParams,
		timesheetParams,
		storeDepartmentParams,
		weeklyOffparams,
		employeeLeaveParams,
		storeTimeParams
	) {
		return axios.all([
			this.getAllEmployeeListNetworkCallBack(employeeListParams),
			this.getEmployeesDayWiseDataNetworkCallBack(
				employeeShiftDetailsParams.store_id,
				employeeShiftDetailsParams.get_all,
				employeeShiftDetailsParams.start_date,
				employeeShiftDetailsParams.end_date
			),
			this.getTimeSheetNetWorkCallBack(timesheetParams),
			this.getStoreDepartments(storeDepartmentParams),
			this.getAllWeeklyOffNetworkCallBack(weeklyOffparams),
			this.getAllLeaveOfEmployeeNetworkCallBack(employeeLeaveParams),
			this.storeOpenCloseTime(storeTimeParams)
		]);
	},
	completeTimesheetDetailskNetworkCallBack(params) {
		return serverAddr.post(`/timesheet/complete-data/list/?get_all=true`, params);
	},
	getManageTimeSheetNetworkCallBack(
		employeeListParams,
		employeeShiftDetailsParams,
		timesheetParams,
		storeDepartmentParams,
		weeklyOffparams,
		employeeLeaveParams,
	) {
		return axios.all([
			this.getAllEmployeeListNetworkCallBack(employeeListParams),
			this.getEmployeesDayWiseDataNetworkCallBack(
				employeeShiftDetailsParams.store_id,
				employeeShiftDetailsParams.get_all,
				employeeShiftDetailsParams.start_date,
				employeeShiftDetailsParams.end_date
			),
			this.getTimeSheetNetWorkCallBack(timesheetParams),
			this.getStoreDepartments(storeDepartmentParams),
			this.getAllWeeklyOffNetworkCallBack(weeklyOffparams),
			this.getAllLeaveOfEmployeeNetworkCallBack(employeeLeaveParams),
		]);
	},
	changeTimesheetShiftStatus(params) {
		return serverAddr.post(`/timesheet/save/`, params);
	},
	changeTimeSheetStatusNetworkCallBack(params) {
		return serverAddr.post(`/timesheet/approval/`, params);
	},
	approveTimeSheetInBulkNetworkCallBack(timesheets) {
		return serverAddr.post(`/timesheet/bulk/approval/`, timesheets);
	},
	updateTodaysTimesheetInBulkNetworkCallBack(timesheets) {
		return serverAddr.patch(`/timesheet/bulk-update/`, timesheets);
	},
	deleteTimesheetInBulkNetworkCallBack(timesheet_obj) {
		return serverAddr.delete(`/timesheet/delete/`, { data: { id: timesheet_obj.id } });
	},
	getWeatherInfoForWeek(params) {
		return serverAddr.get(`/weather/?from_date=${params.start_date}&to_date=${params.end_date}&outlet=${params.outlet_id}`);
	},
	getTargetList(store_id) {
		return serverAddr.get(`/store/target/?store=${store_id}`);
	},
	addTarget(params) {
		return serverAddr.post(`/store/target/`, params);
	},
	updateTarget(params, id) {
		return serverAddr.put(`/store/target/${id}/`, params);
	},
	deleteTarget(id) {
		return serverAddr.delete(`/store/target/${id}/`);
	},
	storeOpenCloseTime(params) {
		return serverAddr.post(`/settings/store/details/open-close-time/`, params);
	},
	getDesignation(params) {
		return serverAddr.post(`/store-designations/list/`, params);
	},
	updateDesignations(params) {
		return serverAddr.post(`/store-designations/save/`, params);
	},
	downloadXmlSchdule(params) {
		return serverAddr.post(`/sheduling/partner/download_excel/`, params);
	},
	uploadTaskFiles(params){
		// return fileServerAddr.post(`/add/attachment_to_task_assignment/`, params);
		return fileServerAddr.post(`/common/upload-image/`, params);
	},
	getDepartmentList(){
		return serverAddr.get(`/product/department/?get_all=true`);
	},
	restoreEmpDetail(params) {
		return serverAddr.post("restore/employee/", params);
	},
	getAllOutletStores() {
		return serverAddr.get("/outlet/?get_all=true&type=central_kitchen,store");
	},
	getCategoryHierarchy() {
		return serverAddr.get("/task/category/hierarchy/");
	},
	getTaskSummaryCompletionStatus(params) {
		return serverAddr.post(`/task_assignment/completion_status/fetch/`, params);
	},
	updateTaskSummayCompletionStatus(params) {
		return serverAddr.post(`/task_assignment/completion_status/save/`, params);
	},
	deleteEmployeeWeeklyShiftPreference(params) {
		return serverAddr.post(`/employee/delete/employee_prefrence/`, params);
	},
	getStoreStaffInfo(params) {
		return serverAddr.post(`/read/store-staff-info/`, params);
	},
	lastAuditConducted(params) {
		return serverAddr.post(`/bk_task_assignment/report/?get_all=true`, params);
	},
	getDashboardSummary(params) {
		return serverAddr.post(`/bk_task_assignment/summary/`, params);
	},
	// Shift Preferences (Custom Shifts) --> Starts
	getAllCustomShifts(store_id) {
		return serverAddr.get(`/read/custom_shifts/?store_id=${store_id}`);
	},
	addCustomShift(param) {
		return serverAddr.post(`/add/update/custom_shifts/`, param);
	},
	deleteCustomShift(param) {
		return serverAddr.post(`/delete/custom_shifts/`, param);
	},
	getSectionsByFunction(store_id) {
		return serverAddr.get(`read/function/function-section/?store=${store_id}`);
	},
	addOrUpdateDailyActivities(payload) {
		return serverAddr.post(`create/update/daily_activities/`, payload);
	},
	getDailyActivitiesByDay(payload) {
		return serverAddr.post(`read/daily_activities_summary/`, payload);
	},
	getSectionWiseManpower(payload) {
		return serverAddr.post(`sheduling/adt-ipt/section-wise-manpower/`, payload);
	},
	getDayWiseSchedulerData(
		getDepartmentParams,
		getWorkAreaParams,
		getStaffDetailsParams,
		getStoreDetailsParams,
		getEmployeesNameParams,
		currentDate,
		getDesignationParams,
		getSectionsByFuncParams,
		getShiftSummaryParams,
		// getPartnerSummaryParams,
		getProjectedValuesNewFuncParams,
		getBreakHourCountFuncParams,
		getIdealLabourHourParams,
		getCoverageHourParams,
		getStoreDepartMentsParams,
		getSectionWiseManpowerParams,
		getCalcFunctionalDeficitParams
	){
		return axios.all([
			this.getDepartment(getDepartmentParams),
			this.getWorkArea(getWorkAreaParams),
			this.getStaffDetails(getStaffDetailsParams),
			this.getAllStoreData(getStoreDetailsParams),
			this.getSortEmployeeListNetworkCallBack(getEmployeesNameParams, currentDate),
			this.getDesignation(getDesignationParams),
			this.getSectionsByFunction(getSectionsByFuncParams),
			this.getShiftSummary(getShiftSummaryParams),
			// this.partnerSummary(getPartnerSummaryParams),
			this.getProjectValuesNetworkCallBack(getProjectedValuesNewFuncParams),
			this.getBreakHourCount(getBreakHourCountFuncParams),
			this.getIdealLabourNetworkCallBack(getIdealLabourHourParams),
			this.getCoverageHoursNetworkCallBack(getCoverageHourParams),
			this.getStoreDepartMentsNetworkCallBack(getStoreDepartMentsParams),
			this.getDeptWiseManpowerNetworkCallBack(getIdealLabourHourParams),
			this.getSectionWiseManpower(getSectionWiseManpowerParams),
			this.getCalcFunctionalDeficit(getCalcFunctionalDeficitParams)
		]);
	},
	updateShiftExtension(payload) {
		return extenapiServerAddr.post(`sheduling/partner/shift-extension/`, payload);
	},
	getStoreTimings(payload) {
		return serverAddr.post(`sheduling/adt-ipt/get-timings/`, payload);
	},
	getCalcFunctionalDeficit(payload) {
		return serverAddr.post(`sheduling/adt-ipt/get_functional_deficit/`, payload);
	},
	getLocationHiererchy() {
		return serverAddr.get(`outlet/location/?type=store,warehouse,central_kitchen,head_office,distribution_centre,regional_office,vendor`);
	},
	// New API for day and week scheduler data
	getEmployeesWeeklyWiseDataNetworkCallBack_V2(params) {
		return serverAddr.get(
			`sheduling/partner/list-shifts-by-employee/?get_all=${params.get_all}&from_date=${params.formDate}&to_date=${params.toDate}&store=${params.storeID}&view=weekly`
			);
		},
	getEmployeesDailyWiseDataNetworkCallBack_V2(params) {
		return serverAddr.get(
			`sheduling/partner/list-shifts-by-employee/?get_all=${params.get_all}&from_date=${params.formDate}&to_date=${params.toDate}&store=${params.storeID}`
		);
	},
	createUpdateShift(payload) {
		return serverAddr.post(`sheduling/partner/save-shifts-for-employee/`, payload);
	},
	deleteShift(payload) {
		return serverAddr.post(`sheduling/partner/delete-shifts-for-employee/`, payload);
	},
	updateOrCreateStorePlan(storeDetailsId, payload) {
		return serverAddr.patch(`/settings/store/details/${storeDetailsId}/`, payload);
	},
	getStoreSectionFunctions(param) {
		return serverAddr.post(`/sections/get-store-sections/`, param);
	},
	addOrUpdateSectionFunction(param) {
		return serverAddr.post(`/sections/save-store-sections/`, param);
	},
	// Sections API (Company Level) Starts
	getSectionsAtCompanyLevel() {
		return serverAddr.get(`/base-sections/get-all-base-sections/`);
	},
	bulkSaveSectionsAtCompanyLevel(params) {
		return serverAddr.post(`/base-sections/save-base-section/`, params);
	},
	deleteSectionAtCompanyLevel(params) {
		return serverAddr.post(`/base-sections/delete-base-section/`, params);
	},
	getCompanyCoverageActivities(params) {
		return serverAddr.post(`/read/store_section_station_activities/`, params);
	},
	createUpdateCoverageActivities(params) {
		return serverAddr.post(`/create/update/store_section_station_activities/`, params);
	},
	deleteUpdatedCoverageActivity(params) {
		return serverAddr.post(`/delete/store_section_station_activities/`, params);
	},
	deleteSectionStationMapping(params) {
		return serverAddr.post(`/sections/delete-nonvcov-sectionsetup/`, params);
	},
	copyAllCompanySettings(params) {
		return serverAddr.post(`/copy/activities-and-guidelines/`, params);
	},
	saveUpdateNonCoverageDailyActivities(params) {
		return serverAddr.post(`/sections/noncov-create-daily-actvites/`, params);
	},
	enableOrDisableDailyActivity(params) {
		return serverAddr.post(`/sections/enable-disable-daily-activity/`, params);
	},
	triggerLabourPlanningForecast(params) {
		return serverAddr.post(`/sheduling/adt-ipt/forecast/`, params);
	},
	getDailyActivitiesUpdatedHourlyView(store_id) {
		return serverAddr.get(`/read/daily_activities_summary_weekly/?store_id=${store_id}`);
	},
	getDailyActivitiesUpdatedSummary(params) {
		return serverAddr.post(`/read/daily_activities_summary/`, params);
	},
	createOrUpdateDailyActivitiesHourlyData(params) {
		return serverAddr.post(`/create/update/daily_activities_hourly/`, params);
	},
	// Sections API (Company Level) Ends
	
	// Monthly schedule API's lists
	getAllMonthlyEmployeeList(payload) {
		return serverAddr.post(`scheduling/monthly/employee-list/`, payload);
	},
	getAllMonthlyShiftsData(payload) {
		return serverAddr.post(`scheduling/monthly/get-fixed-assignments/`, payload);
	},
	getAllMonthlyShiftWiseAss(payload) {
		return serverAddr.post(`scheduling/monthly/get-shiftwise-assignment/`, payload);
	},
	saveAllMonthlyShiftsData(payload) {
		return serverAddr.post(`scheduling/monthly/save-fixed-assignments/`, payload);
	},
	clearEmployeeShift(payload) {
		return serverAddr.post(`scheduling/monthly/clear-employee-assignment/`, payload);
	},
	publishMonthlyPlanner(payload) {
		return serverAddr.post(`scheduling/monthly/publish-fixed-assignments/`, payload);
	},
	getMonthlySchedulerData(
		getEmployeePayload,
		getShiftsPayload,
		getShiftsWiseAssPayload,
		getEmpLeavesParams
	){
		return axios.all([
			this.getAllMonthlyEmployeeList(getEmployeePayload),
			this.getAllMonthlyShiftsData(getShiftsPayload),
			this.getAllMonthlyShiftWiseAss(getShiftsWiseAssPayload),
			this.getAllLeaveOfEmployeeNetworkCallBack(getEmpLeavesParams),
		]);
	},
	getUpdatedShiftData(
		getShiftsPayload,
		getShiftsWiseAssPayload,
	){
		return axios.all([
			this.getAllMonthlyShiftsData(getShiftsPayload),
			this.getAllMonthlyShiftWiseAss(getShiftsWiseAssPayload)
		]);
	},
	// Monthly schedule API's lists

	// Project transaction day planner api
	updateHourlyQuantity(payload) {
		return serverAddr.post(`sheduling/adt-ipt/update-hourly-quantity/`, payload);
	},
	updateProjectedTransactionData(transactions, qty_data){
		return axios.all([
			this.saveHourlyTransactionsNetWorkCallBack(transactions),
			this.updateHourlyQuantity(qty_data)
		]);
	},
	saveHourlyOrderTypeNetWorkCallBack(payload) {
		return serverAddr.post(`sheduling/adt-ipt/update-ordertype-hourly-transactions/`, payload);
	},
	getAllTaskAndAuditOutlets() {
		return serverAddr.get(`/outlet/?get_all=true&type=store,central_kitchen`);
	},
	getStepLocations(params) {
		return serverAddr.post(`/task_assignment/steps/report/?get_all=true`, params);
	},
	getTaskAttachmentNew(params) {
        return serverAddr.post(`/get/subtask/attachment/`, params);
    },
	approveAllTimeSheet(params) {
        return serverAddr.post(`/timesheet/bulk/approval/`, params);
    },
	saveTimeSheet(params) {
        return serverAddr.post(`/timesheet/save/`, params);
    },
	updateTimeSheet(params) {
        return serverAddr.patch(`/timesheet/update/`, params);
    },
	getProcessStatus(params) {
        return serverAddr.get(`/outlet/process-status/get-outlet-process-status?outlet_id=${params.outlet_id}&date=${params.start_date}`);
    },
	getFixedActivitySummary(outlet_id) {
        return serverAddr.get(`/read/fixed_activities_summary_weekly/?store_id=${outlet_id}`);
    },
	updateFixedActivitySummary(payload) {
        return serverAddr.post(`/create/update/fixed_activities_hourly/`,payload);
    },
	getMonthlyScheduleApproveInfo(payload) {
        return serverAddr.post(`/scheduling/monthly/monthly-schedule-approval-info/`,payload);
    },
	reqMonthlyScheduleApproval(payload) {
        return serverAddr.post(`/scheduling/monthly/request_monthly_schedule_approval/`,payload);
    },
	approveMonthlySchedule(payload) {
        return serverAddr.post(`/scheduling/monthly/approve_monthly_schedule/`,payload);
    },
	downloadMonthlySchedule(payload) {
        return serverAddr.post(`/download-monthly-schedule/`,payload);
    },
	// Cluster
	getAllClusters() {
		return serverAddr.get(`/wfcluster/list-cluster-outlets/`);
	},
	saveCluster(params) {
		return serverAddr.post(`/wfcluster/save-cluster-outlets/`, params);
	},
	saveCluster(params) {
		return serverAddr.post(`/wfcluster/save-cluster-outlets/`, params);
	},
	deleteCluster(cluster_id) {
		return serverAddr.get(`/wfcluster/delete-cluster/?cluster_id=${cluster_id}`);
	},
	getClusterEmployeesForOutlet(params) {
		return serverAddr.post(`/wfcluster/get-cluster-employees-for-outlet/`, params);
	},
	getEmpAvailabilityForCluster(params) {
		return serverAddr.post(`/wfcluster/get-cluster-employees-availability/`, params);
	},
	getClusterDetailsById(cluster_id) {
		return serverAddr.get(`/wfcluster/get-cluster-by-id/?cluster_id=${cluster_id}`);
	},
	getClusterRequestList(params) {
		return serverAddr.post(`/wfcluster/list-cluster-requests/`, params);
	},
	getImageUrlByPath(params) {
		return serverAddr.post(`/common/get-attachment-url/`, params);
	},
	changeClusterRequestStatus(params) {
		return serverAddr.post(`/wfcluster/save-cluster-employee-request/`, params);
	},
	approveClusterRequest(params) {
		return serverAddr.post(`/wfcluster/process-cluster-request/`, params);
	},
	getClusterForOutlet(params) {
		return serverAddr.post(`/wfcluster/get-cluster-for-outlet/`, params);
	},
	getClusterDataNetworkCallBack(
		employessForCluster,
		empAvailabilityParams
	) {
		return axios.all([
			this.getClusterEmployeesForOutlet(employessForCluster),
			this.getEmpAvailabilityForCluster(empAvailabilityParams),
		]);
	},
	deleteClusterById(cluster_id) {
		return serverAddr.get(`/wfcluster/delete-cluster-request-by-id/?cluster_request_id=${cluster_id}`);
	},
	getTrainingSchedule(param) {
        return serverAddr.get(`/train/training_schedule/view-schedule/?start_date=${param.start_date}&end_date=${param.end_date}&store_id=${param.store_id}`);
    },
	getTrainingType(param) {
        return serverAddr.get(`/train/training_view/view-training/?store_id=${param.store_id}`);
    },
	// VCMS endpoints
	saveNewStation(payload) {
		return serverAddr.post(`/vcms/storeproductionstation/save-stations/`, payload);
	},
	getStoreProdSetup(payload) {
		return serverAddr.post(`/vcms/storeproductionsetup/get-setup/`, payload);
	},
	saveStoreProdSetup(payload) {
		return serverAddr.post(`/vcms/storeproductionsetup/save-setup/`, payload);
	},
	deleteStoreProdSetup(payload) {
		return serverAddr.post(`/vcms/storeproductionsetup/delete-setup/`, payload);
	},
	getArticlesForOutlet(payload) {
		return serverAddr.post(`/vcms/articles/get-articles/`, payload);
	},
	getStoreProdStation(payload){
		return serverAddr.post(`/vcms/storeproductionstation/get-stations/`, payload);
	},
	getVcmsForecastData(payload){
		return serverAddr.post(`/vcms/forecast/query/`, payload);
	},
	getVcmsForecastQtyData(payload){
		return serverAddr.post(`/vcms/forecast/item-query/`, payload);
	},
	getProdSegment(payload){
		return serverAddr.post(`/vcms/productionsegment/get-segments/`, payload);
	},
	getForecastData(
		forecastPayload,
		article_payload
	) {
		return axios.all([
			this.getVcmsForecastData(forecastPayload),
			this.getArticlesForOutlet(article_payload),
		]);
	},
	//  Monthly scheduler for secondary store  API's lists
	getEmployeeListForSecondaryStore(payload) {
		return serverAddr.post(`/scheduling/monthly/employee-list-for-secondary-stores/`, payload);
	},
	getShiftDataForSecondaryStore(payload) {
		return serverAddr.post(`/scheduling/monthly/get-fixed-assignments-for-secondary-stores/`, payload);
	},
	getCustomShiftsForSecondaryStore(payload) {
		return serverAddr.get(`/read/custom_shifts_secondary_stores/?store_id=${payload.outlet_id}`);
	},
	// Leave type
	getLeaveType() {
		return serverAddr.get(`/employee/leaves/list-leave-type/`);
	},
	// Monthly Schedule new APIs
	deleteShiftByDate(payload) {
		return serverAddr.post(`/scheduling/monthly/clear-employee-assignment-by-date/`, payload);
	},
	deleteSiftByEmp(payload){
		return serverAddr.post(`/scheduling/monthly/clear-employee-assignment-by-employee/`, payload);
	},
	publishSchedule(payload){
		return serverAddr.post(`/sheduling/partner/push-employee-schedule/`, payload);
	},
	exportFixedHours(payload){
		return serverAddrForCSV.post(`/read/fixed_activities_summary_report/`, payload);
	},
	getCompanyConfig() {
		return serverAddr.get("/company/companyconfig/list/");
	},
	// Settings API for PLS
	getDayParts() {
		return serverAddr.get(`settings/company-day-part/get-day-part/`);
	},
	createUpdateDayParts(payload) {
		return serverAddr.post(`settings/company-day-part/create-update-day-part/`, payload);
	},
	deleteDayPart(payload) {
		return serverAddr.post(`settings/company-day-part/delete-day-part/`, payload);
	},
	getProdStation(payload) {
		return serverAddr.post(`/vcms/productionstation/get-stations/`, payload);
	},
};
